/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'jquery',
	'../../../lib/@waca/dashboard-common/dist/utils/FlyoutContentBase',
	'doT',
	'text!./templates/ForecastOptionsList.html',
	'react-dom',
	'react',
	'underscore',
	'./ForecastFlyoutComponent'
], function($, FlyoutContentBase, dot, ForecastOptionsList, ReactDOM, React, _, ForecastFlyoutComponent) {
	'use strict';

	const ForecastOptionsListTemplate = dot.template(ForecastOptionsList);

	const ForecastView = FlyoutContentBase.extend({
		init: function(options) {
			ForecastView.inherited('init', this, arguments);
			this.visAPI = options.viewOptions.visAPI;
			this.uniqueId = options.viewOptions.uniqueId;
			this.popOver = null;
			this.markup = ForecastOptionsListTemplate({
				'title': 'Forecast'
			});
			this.content = options.viewOptions.content;
		},

		setFocus: function() {
			this.popOver = $('.forecastPopover.' + this.uniqueId);
			this.popOver.find('input:first').focus();
		},

		_onRemove() {
			// if a popOver has not been created, do not try to remove it
			if (this.popOver) {
				// We need to unmount the react components so that, when the popup is re-opened
				// React knows that the state has changed and will actually render the
				// components again.
				const popoverContent = this.popOver.find('.popover-content')[0];
				if ($(popoverContent).find('.forecastComponents').length > 0) {
					ReactDOM.unmountComponentAtNode(popoverContent);
				}

				// Popover needs to be removed as well.
				this.popOver.remove();
			}
			this.popupShown = false;
			this.reactComponents = null;
		},

		remove: function() {
			ForecastView.inherited('remove', this, arguments);
			this._onRemove();
		},

		//@override
		onPopupClosed: function() {
			this._onRemove();
		},

		/* TODO: React needs to have a dom element to render, flyouts work by
		* asking for rendered html. For now render a basic template and then
		* when the popup is shown add the react components.
		*/
		getRenderedHtml: function() {
			// If the indicator is selected while the popover is open the flyout code
			// acts stupid and tries to re-render from scratch, which means getting
			// the base html and tossing the old popover. We need to unmount the React
			// components in this case.
			if (this.popOver && this.popOver.find('.popover-content')[0]) {
				const popoverContent = this.popOver.find('.popover-content')[0];
				if ($(popoverContent).find('.forecastComponents').length > 0) {
					ReactDOM.unmountComponentAtNode(popoverContent);
				}
			}
			return this.markup;
		},

		onPopupShown: function() {
			// Find the anchor node (i.e. the popover content)
			const popOverDom = this.popOver.find('.popover-content')[0];
			// If the popup isn't shown build it
			if (!this.popupShown) {
				let initialState = _.clone(this.content.getFeature('Forecast').getForecastDisplayState());
				this.popupShown = true;

				// Render the react components
				this.reactComponents = ReactDOM.render(<ForecastFlyoutComponent
					initialState={initialState}
					onForecastValuesStateChanged={state=>this.onForecastValuesStateChanged(state)}
				/>,
				popOverDom
				);
				this.setFocus();
			}
		},

		onForecastValuesStateChanged(state) {
			this.content.getFeature('Forecast').applyStateChange(state);
		}
	});
	return ForecastView;
});
